import { useEffect } from "react";

const setMeta = (name, content) => {
  const el = document.querySelector(`meta[name="${name}"]`);
  if (el) el.setAttribute("content", content);
};

export const usePageMeta = ({ title, description, noindex = false }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("description", description);
    setMeta("robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
  }, [title, description, noindex]);
};
